export default __webpack_public_path__ + "static/media/208.26b787c0.jpg";